module.exports = __webpack_public_path__ + "static/media/a79.8d9df64c.jpg";